import React, { FC } from 'react';

import { useSiteMetadata } from '@lucid/utils';

import ABTest, { ABTestVariation } from '../../ab-test/ab-test';
import ABTestBranch from '../../ab-test-branch/ab-test-branch';
import MarketoForm, { MarketoFormProps } from '../../marketo-form/marketo-form';
import AbTestBranch from '../../ab-test-branch/__mocks__/ab-test-branch';

interface RestrictFreeDomainsProps extends MarketoFormProps {
  langPrefix: string;
  test: string;
  topTextHeading: string;
}

const RestrictFreeDomains: FC<RestrictFreeDomainsProps> = ({
  children,
  langPrefix,
  test,
  topText,
  topTextHeading,
  ...rest
}) => {

  const { product } = useSiteMetadata();

  const signUpUrl = `https://lucid.app/pricing/lucid${product}#/pricing`;
  let updatedTopText =
    "We'll be in touch soon to answer your Enterprise Questions. ";
  if (product !== 'co') {
    updatedTopText += `Need a personal or team plan? Sign up <a href="${signUpUrl}" rel="noreferrer"> here</a>.`;
  }

  const { form: { childrenMarketoFormField } } = rest;
  const isSalesForm = !!childrenMarketoFormField?.find(field => field.marketoId === 'LeadSource');

  return (
    <ABTest
      isAboveTheFold
      hasConditionalTrigger={langPrefix === 'en' && isSalesForm}
      test={test}
      trigger="load"
    >
      <ABTestBranch branch={ABTestVariation.A}>
        <MarketoForm {...rest} topText={topText}>
          {children}
        </MarketoForm>
      </ABTestBranch>
      <AbTestBranch branch={ABTestVariation.B}>
        <MarketoForm
          {...rest}
          willRestrictFreeDomains
          topText={{
            body: `<h1 style="margin-top:0; font-size: 1.5rem">${topTextHeading}</h1>
            <p>${updatedTopText}</p>`
          }}
        >
          {children}
        </MarketoForm>
      </AbTestBranch>
    </ABTest>
  );
};

export default RestrictFreeDomains;
